import React from 'react';
import { Receipt } from '../../../../../../../types/clientReceipts';
import { formatCurrency, formatDate } from '../../../../../../../utils/formatters';
import './PendingCard.scss';

interface PendingCardProps {
  receipt: Receipt;
  onLeaveReview?: (receipt: Receipt) => void;
}

const PendingCard: React.FC<PendingCardProps> = ({ receipt, onLeaveReview }) => {
  return (
    <div className="pending-card">
      <div className="pending-header">
        <div className="pending-info">
          <h3>Recibo #{receipt.receipt_number}</h3>
          <p className="pending-date">{formatDate(receipt.timestamp)}</p>
        </div>
        <div className="pending-amount">
          <span className="amount-label">Total</span>
          <span className="amount-value">{formatCurrency(receipt.total_payed)}</span>
        </div>
      </div>

      {/* Display items briefly */}
      {receipt.selections && receipt.selections.length > 0 && (
        <div className="pending-items">
          <div className="items-summary">
            {receipt.selections.slice(0, 2).map((item, index) => (
              <div key={index} className="item-preview">
                <span className="item-qty">{item.quantity}x</span>
                <span className="item-name">{item.name || item.item_name || 'Item'}</span>
              </div>
            ))}
            {receipt.selections.length > 2 && (
              <span className="more-items">
                +{receipt.selections.length - 2} más
              </span>
            )}
          </div>
        </div>
      )}

      <div className="pending-action">
        <button 
          className="leave-review-btn"
          onClick={() => onLeaveReview && onLeaveReview(receipt)}
        >
          <span className="btn-icon">⭐</span>
          <span className="btn-text">Dejar Reseña</span>
        </button>
        <p className="pending-message">
          ¡Nos encantaría saber tu opinión!
        </p>
      </div>
    </div>
  );
};

export default PendingCard;
